import React, { PropsWithChildren } from 'react';
import componentProps from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { CardsContainerProps } from '../types';
import { CardGridItem, GridWithMargins } from './styles';

/**
 * A generic component for creating card layouts.
 *
 * The column span of a card is calculated using the supplied columnSpanCalculator, which
 * calculates the column spans based on the index of the card, and the total number of cards.
 */
const CardGrid: React.FC<PropsWithChildren<CardsContainerProps>> = ({
  columnSpanCalculator,
  alignLeft,
  children,
  ...props
}) => {
  const totalCards = React.Children.count(children);
  return (
    <GridWithMargins alignLeft={alignLeft} {...componentProps(props)}>
      {React.Children.map(
        children,
        (child, index) =>
          child && (
            <CardGridItem {...columnSpanCalculator(index, totalCards)}>
              {child}
            </CardGridItem>
          )
      )}
    </GridWithMargins>
  );
};

export default applyComponentTheme(CardGrid, 'CardGrid');
